export const plData = `
  <div class="paragraph">
    <div class="text-box">
      <div class="text">Aby ułatwić Państwu zrozumienie, w jaki sposób przetwarzamy dane osobowe, przygotowaliśmy krótkie podsumowanie naszej Polityki Prywatności. Szczegółowe informacje znajdują się w pełnej wersji Polityki Prywatności poniżej. Zalecamy również zapoznanie się z pełną wersją Polityki Prywatności, aby dokładnie zrozumieć, w jaki sposób przetwarzamy Państwa dane osobowe oraz jakie prawa i możliwości przysługują Państwu w związku z tymi danymi.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Najważniejsze informacje</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">Podsumowanie</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kto odpowiada za gromadzenie i wykorzystywanie Państwa danych?</div>
    <div class="text-box">
      <div class="text">Co do zasady Danghuan odpowiada za gromadzenie i wykorzystywanie Państwa danych osobowych. W przypadku osób znajdujących się w Europie administratorem danych osobowych jest Danghuan Europe S.L.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Jakie dane wykorzystujemy?</div>
    <div class="text-box">
      <div class="text">Przetwarzamy dane przekazywane nam bezpośrednio przez Państwa lub gromadzone podczas korzystania z naszych Usług. Możemy również otrzymywać Państwa dane osobowe od podmiotów trzecich oraz platform partnerskich.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">W jakim celu wykorzystujemy dane?</div>
    <div class="text-box">
      <div class="text">Wykorzystujemy Państwa dane osobowe wyłącznie wtedy, gdy istnieje ku temu odpowiednia podstawa prawna, w tym w celu wykonania umowy, wypełnienia obowiązków prawnych, realizacji naszych prawnie uzasadnionych interesów lub na podstawie Państwa zgody.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Jak długo przechowujemy dane?</div>
    <div class="text-box">
      <div class="text">Nie przechowujemy Państwa danych osobowych dłużej, niż jest to konieczne do realizacji celów opisanych w niniejszej Polityce Prywatności, chyba że przepisy prawa wymagają dłuższego okresu przechowywania.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Marketing</div>
    <div class="text-box">
      <div class="text">Możemy przesyłać Państwu informacje o naszych Usługach lub ofertach, które mogą Państwa zainteresować. W przypadkach wymaganych przez prawo będziemy to robić wyłącznie za Państwa zgodą.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Udostępnianie danych osobowych</div>
    <div class="text-box">
      <div class="text">Możemy udostępniać Państwa dane osobowe spółkom powiązanym, dostawcom usług logistycznych, partnerom płatniczym, platformom partnerskim oraz innym usługodawcom, jeżeli jest to konieczne do świadczenia naszych Usług lub wykonania obowiązków prawnych.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Bezpieczeństwo</div>
    <div class="text-box">
      <div class="text">Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Państwa danych osobowych.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Państwa prawa</div>
    <div class="text-box">
      <div class="text">W zależności od obowiązujących przepisów mogą Państwu przysługiwać prawa do dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania lub wniesienia sprzeciwu wobec przetwarzania.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dzieci</div>
    <div class="text-box">
      <div class="text">Nasze Usługi są przeznaczone dla użytkowników, którzy ukończyli 18 lat.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Międzynarodowe przekazywanie danych</div>
    <div class="text-box">
      <div class="text">Państwa dane osobowe mogą być przekazywane do innych państw przy zastosowaniu odpowiednich zabezpieczeń.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Aktualizacje</div>
    <div class="text-box">
      <div class="text">Możemy okresowo aktualizować niniejszą Politykę Prywatności.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kontakt</div>
    <div class="text-box">
      <div class="text">W przypadku pytań można skontaktować się z nami pod adresem:<span class="email">privacy@danghuan.eu</span></div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">POLITYKA PRYWATNOŚCI</div>
    <div class="text-box">
      <div class="text">Niniejsza Polityka Prywatności opisuje, w jaki sposób Danghuan Europe S.L. oraz jej spółki powiązane („Danghuan”, „my”, „nas” lub „nasze”) gromadzą, wykorzystują, ujawniają, przekazują, przechowują oraz w inny sposób przetwarzają Państwa dane osobowe podczas korzystania z naszych usług, w tym naszych stron internetowych, usług odkupu urządzeń, usług odsprzedaży, usług logistycznych, platform internetowych oraz innych powiązanych usług (łącznie zwanych dalej „Usługami”).</div>
      <div class="text">Prosimy o uważne zapoznanie się z niniejszą Polityką Prywatności oraz naszymi zasadami dotyczącymi prywatności przed rozpoczęciem korzystania z naszych Usług lub przekazaniem nam danych osobowych.</div>
      <div class="text">Oprócz niniejszej Polityki Prywatności w odniesieniu do określonych Usług mogą mieć zastosowanie dodatkowe informacje dotyczące prywatności. W odpowiednich przypadkach udostępnimy Państwu odpowiednie dodatkowe informacje.</div>
      <div class="text">Ogólne postanowienia Sekcji A mają zastosowanie niezależnie od Państwa miejsca zamieszkania. Sekcja B ma zastosowanie wyłącznie do klientów znajdujących się w Unii Europejskiej, Liechtensteinie, Norwegii, Zjednoczonym Królestwie lub Szwajcarii („Europa”).</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">A. POSTANOWIENIA OGÓLNE</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Odpowiedzialność</div>
    <div class="text-box">
      <div class="text">Prowadzimy działalność i oferujemy nasze Usługi na całym świecie. Zakres naszych Usług może jednak różnić się w zależności od miejsca Państwa zamieszkania.</div>
      <div class="text">• Danghuan Europe S.L. jako administrator danych:Jeżeli mieszkają Państwo w Europie, Danghuan Europe S.L. odpowiada za przetwarzanie Państwa danych osobowych w sposób opisany w niniejszej Polityce Prywatności.</div>
      <div class="text">• Co do zasady Danghuan odpowiada za przetwarzanie i sprawuje kontrolę nad przetwarzaniem danych osobowych zebranych za pośrednictwem Usług poza Europą oraz zobowiązuje się do ochrony i poszanowania Państwa prywatności.</div>
      <div class="text">Określenia „Danghuan”, „my” oraz „nas” odnoszą się zatem do Danghuan Europe S.L. lub odpowiedniego podmiotu powiązanego, w zależności od Państwa lokalizacji.</div>
      <div class="text">Należy pamiętać, że w związku z usługami logistycznymi, przetwarzaniem płatności, obsługą posprzedażową lub transakcjami realizowanymi za pośrednictwem platform partnerskich niektórzy upoważnieni partnerzy lub zewnętrzni usługodawcy mogą niezależnie przetwarzać Państwa dane osobowe w związku ze świadczonymi przez nich usługami.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. W jaki sposób gromadzimy dane osobowe i jakie rodzaje danych osobowych gromadzimy</div>
    <div class="text-box">
      <div class="text">Termin „dane osobowe” oznacza wszelkie informacje dotyczące zidentyfikowanej lub możliwej do zidentyfikowania osoby fizycznej.</div>
      <div class="text">Dane osobowe możemy gromadzić za pośrednictwem następujących kanałów:</div>
      <div class="text">• dane osobowe przekazywane nam bezpośrednio przez Państwa;</div>
      <div class="text">• dane osobowe gromadzone automatycznie podczas korzystania z naszych Usług;</div>
      <div class="text">• dane osobowe uzyskane od podmiotów trzecich lub platform partnerskich.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. Dane osobowe przekazywane bezpośrednio przez Państwa</div>
    <div class="text-box">
      <div class="text">Mogą Państwo przekazywać nam dane osobowe bezpośrednio. Jeżeli jednak określone dane osobowe są niezbędne do świadczenia naszych Usług, a zdecydują się Państwo ich nie przekazywać, możemy nie być w stanie świadczyć żądanych Usług.</div>
      <div class="text">Dane osobowe, które możemy zbierać bezpośrednio od Państwa, obejmują:</div>
      <div class="text">• imię i nazwisko, adres, adres e-mail oraz numer telefonu;</div>
      <div class="text">• dane rozliczeniowe i dane dotyczące dostawy;</div>
      <div class="text">• IBAN, dane rachunku bankowego, PayPal, Revolut lub inne informacje dotyczące płatności;</div>
      <div class="text">• informacje o urządzeniu, takie jak marka, model, IMEI, numer seryjny, stan urządzenia i szczegóły wyceny;</div>
      <div class="text">• historię transakcji, wnioski o zwrot środków, wnioski o zwrot urządzenia oraz historię komunikacji;</div>
      <div class="text">• komunikację z działem obsługi klienta;</div>
      <div class="text">• informacje przekazywane w ankietach, kampaniach, promocjach lub konkursach;</div>
      <div class="text">• preferencje marketingowe oraz subskrypcje newslettera.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. Dane osobowe gromadzone automatycznie</div>
    <div class="text-box">
      <div class="text">Oprócz danych osobowych przekazywanych przez Państwa możemy automatycznie zbierać informacje dotyczące korzystania z naszych Usług, w tym:</div>
      <div class="text">• adres IP;</div>
      <div class="text">• typ i wersję przeglądarki;</div>
      <div class="text">• system operacyjny;</div>
      <div class="text">• identyfikatory sesji;</div>
      <div class="text">• identyfikatory urządzenia;</div>
      <div class="text">• informacje o geolokalizacji;</div>
      <div class="text">• dane dotyczące interakcji ze stroną internetową;</div>
      <div class="text">• odwiedzane strony oraz sposób przeglądania;</div>
      <div class="text">• informacje z logów;</div>
      <div class="text">• pliki cookie oraz informacje związane ze śledzeniem.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Dane osobowe uzyskiwane od podmiotów trzecich</div>
    <div class="text-box">
      <div class="text">Możemy uzyskiwać dane osobowe od:</div>
      <div class="text">• Shopify;</div>
      <div class="text">• Amazon;</div>
      <div class="text">• TEMU;</div>
      <div class="text">• Back Market;</div>
      <div class="text">• dostawców usług płatniczych;</div>
      <div class="text">• dostawców usług logistycznych;</div>
      <div class="text">• dostawców usług zapobiegania oszustwom;</div>
      <div class="text">• partnerów marketingowych i analitycznych;</div>
      <div class="text">• publicznych baz danych, jeżeli jest to dozwolone przez prawo.</div>
      <div class="text">Informacje te mogą obejmować dane dotyczące zamówień, dostawy, potwierdzenia transakcji oraz informacje wykorzystywane do zapobiegania oszustwom.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Dane niebędące danymi osobowymi</div>
    <div class="text-box">
      <div class="text">Możemy przetwarzać zagregowane lub zanonimizowane informacje, które nie pozwalają na bezpośrednią identyfikację Państwa.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III. W jaki sposób wykorzystujemy Państwa dane osobowe</div>
    <div class="text-box">
      <div class="text">Wykorzystujemy Państwa dane osobowe w następujących celach:</div>
      <div class="text">• świadczenia naszych Usług;</div>
      <div class="text">• realizacji transakcji odkupu, odsprzedaży, płatności, wysyłki, zwrotów i zwrotów środków;</div>
      <div class="text">• organizacji usług logistycznych i dostaw;</div>
      <div class="text">• weryfikacji informacji o urządzeniu oraz jego własności;</div>
      <div class="text">• komunikowania się z Państwem w sprawie transakcji lub zgłoszeń do obsługi klienta;</div>
      <div class="text">• świadczenia obsługi klienta;</div>
      <div class="text">• ulepszania naszych Usług i doświadczenia użytkownika;</div>
      <div class="text">• zapobiegania oszustwom i analizy ryzyka;</div>
      <div class="text">• prowadzenia analiz wewnętrznych i działalności operacyjnej;</div>
      <div class="text">• przesyłania komunikacji marketingowej, jeżeli jest to dozwolone;</div>
      <div class="text">• zarządzania promocjami, kampaniami i konkursami;</div>
      <div class="text">• wykonywania obowiązków prawnych;</div>
      <div class="text">• dochodzenia roszczeń prawnych lub obrony przed nimi.</div>
      <div class="text">Nie podejmujemy decyzji opartych wyłącznie na zautomatyzowanym przetwarzaniu, które wywoływałyby wobec Państwa skutki prawne lub w podobny sposób istotnie na Państwa wpływały.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. W jaki sposób wykorzystujemy pliki cookie i podobne technologie</div>
    <div class="text-box">
      <div class="text">Na naszych stronach internetowych i w ramach naszych Usług wykorzystujemy pliki cookie oraz podobne technologie.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. Czym są pliki cookie?</div>
    <div class="text-box">
      <div class="text">Pliki cookie to niewielkie pliki tekstowe przechowywane na Państwa urządzeniu.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. W jaki sposób wykorzystujemy pliki cookie?</div>
    <div class="text-box">
      <div class="text">Wykorzystujemy pliki cookie w celu:</div>
      <div class="text">• zapewnienia działania naszych Usług;</div>
      <div class="text">• zapamiętywania preferencji użytkownika;</div>
      <div class="text">• analizowania ruchu na stronie internetowej;</div>
      <div class="text">• poprawy funkcjonalności strony internetowej;</div>
      <div class="text">• personalizowania treści i reklam;</div>
      <div class="text">• pomiaru skuteczności reklam.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Rodzaje danych zbieranych za pomocą plików cookie</div>
    <div class="text-box">
      <div class="text">Mogą one obejmować:</div>
      <div class="text">• adresy IP;</div>
      <div class="text">• typ przeglądarki;</div>
      <div class="text">• system operacyjny;</div>
      <div class="text">• odwiedzane strony;</div>
      <div class="text">• dane dotyczące sesji;</div>
      <div class="text">• informacje o kliknięciach;</div>
      <div class="text">• informacje dotyczące lokalizacji.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Śledzenie i reklamy podmiotów trzecich</div>
    <div class="text-box">
      <div class="text">Możemy współpracować z zewnętrznymi partnerami, takimi jak Google, Meta, TikTok oraz innymi dostawcami usług analitycznych lub reklamowych.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">5. Zarządzanie plikami cookie</div>
    <div class="text-box">
      <div class="text">Mogą Państwo zarządzać plikami cookie lub je wyłączyć za pomocą ustawień swojej przeglądarki albo preferencji dostępnych w banerze cookie.</div>
      <div class="text">Przykładowe pliki cookie, których możemy używać:</div>
      <div class="text">Kategoria</div>
      <div class="text">Nazwa</div>
      <div class="text">Dostawca</div>
      <div class="text">Cel</div>
      <div class="text">Okres</div>
      <div class="text">Typ</div>
      <div class="text">Ściśle niezbędne</div>
      <div class="text">session_id</div>
      <div class="text">danghuan.eu</div>
      <div class="text">Zarządzanie sesją użytkownika</div>
      <div class="text">Sesja</div>
      <div class="text">Własne</div>
      <div class="text">Funkcjonalne</div>
      <div class="text">language_pref</div>
      <div class="text">danghuan.eu</div>
      <div class="text">Zapamiętywanie preferencji językowych</div>
      <div class="text">1 rok</div>
      <div class="text">Własne</div>
      <div class="text">Analityczne</div>
      <div class="text">_ga</div>
      <div class="text">Google Analytics</div>
      <div class="text">Analityka strony internetowej</div>
      <div class="text">2 lata</div>
      <div class="text">Zewnętrzne</div>
      <div class="text">Reklamowe</div>
      <div class="text">_fbp</div>
      <div class="text">Meta</div>
      <div class="text">Pomiar skuteczności reklam</div>
      <div class="text">3 miesiące</div>
      <div class="text">Zewnętrzne</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. Jak długo przechowujemy Państwa dane osobowe</div>
    <div class="text-box">
      <div class="text">Przechowujemy Państwa dane osobowe wyłącznie przez okres niezbędny do realizacji celów opisanych w niniejszej Polityce Prywatności, chyba że przepisy prawa wymagają dłuższego okresu przechowywania.</div>
      <div class="text">Po upływie odpowiedniego okresu przechowywania usuniemy lub zanonimizujemy Państwa dane osobowe.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VI. W jaki sposób udostępniamy Państwa dane osobowe</div>
    <div class="text-box">
      <div class="text">Możemy udostępniać Państwa dane osobowe:</div>
      <div class="text">• spółkom powiązanym;</div>
      <div class="text">• dostawcom usług płatniczych, takim jak PayPal, Revolut, VISA, Mastercard i Stripe;</div>
      <div class="text">• dostawcom usług logistycznych, takim jak UPS, Correos, DPD, Royal Mail, NACEX i FedEx;</div>
      <div class="text">• platformom partnerskim, takim jak Shopify, Amazon, TEMU i Back Market;</div>
      <div class="text">• dostawcom usług marketingowych i analitycznych;</div>
      <div class="text">• profesjonalnym doradcom oraz dostawcom usług IT;</div>
      <div class="text">• organom administracji publicznej i organom regulacyjnym, jeżeli wymagają tego przepisy prawa.</div>
      <div class="text">Nie sprzedajemy Państwa danych osobowych podmiotom trzecim.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VII. Międzynarodowe przekazywanie danych osobowych</div>
    <div class="text-box">
      <div class="text">Państwa dane osobowe mogą być przekazywane do i przetwarzane w państwach znajdujących się poza Państwa jurysdykcją.</div>
      <div class="text">Jeżeli wymagają tego przepisy prawa, stosujemy odpowiednie zabezpieczenia, w tym:</div>
      <div class="text">• standardowe klauzule umowne;</div>
      <div class="text">• decyzje stwierdzające odpowiedni stopień ochrony;</div>
      <div class="text">• inne prawnie uznane mechanizmy przekazywania danych.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VIII. W jaki sposób chronimy Państwa dane osobowe</div>
    <div class="text-box">
      <div class="text">Stosujemy techniczne i organizacyjne środki bezpieczeństwa, w tym:</div>
      <div class="text">• szyfrowanie;</div>
      <div class="text">• bezpieczne przechowywanie;</div>
      <div class="text">• kontrolę dostępu;</div>
      <div class="text">• procedury uwierzytelniania;</div>
      <div class="text">• wewnętrzne zobowiązania dotyczące poufności;</div>
      <div class="text">• monitorowanie oszustw;</div>
      <div class="text">• bezpieczne metody transmisji danych.</div>
      <div class="text">Należy jednak pamiętać, że żaden system przesyłania ani przechowywania danych nie jest całkowicie bezpieczny.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IX. Państwa prawa dotyczące danych osobowych</div>
    <div class="text-box">
      <div class="text">W zależności od obowiązujących przepisów mogą Państwu przysługiwać następujące prawa:</div>
      <div class="text">• prawo dostępu do danych osobowych;</div>
      <div class="text">• prawo do sprostowania nieprawidłowych danych;</div>
      <div class="text">• prawo do usunięcia danych osobowych;</div>
      <div class="text">• prawo do ograniczenia przetwarzania;</div>
      <div class="text">• prawo do wniesienia sprzeciwu wobec przetwarzania;</div>
      <div class="text">• prawo do przenoszenia danych;</div>
      <div class="text">• prawo do wycofania zgody;</div>
      <div class="text">• prawo do wniesienia skargi do organu nadzorczego.</div>
      <div class="text">W celu skorzystania z przysługujących praw można skontaktować się z nami pod adresem: <span class="email">privacy@danghuan.eu</span></div>
      <div class="text">Przed rozpatrzeniem Państwa wniosku możemy wymagać weryfikacji tożsamości.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">X. W jaki sposób przetwarzamy dane osobowe dzieci</div>
    <div class="text-box">
      <div class="text">Nasze Usługi są przeznaczone dla osób dorosłych, które ukończyły 18 lat.</div>
      <div class="text">Jeżeli stwierdzimy, że zebraliśmy dane osobowe dziecka bez odpowiedniej zgody, usuniemy je tak szybko, jak będzie to możliwe.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XI. Strony internetowe podmiotów trzecich</div>
    <div class="text-box">
      <div class="text">Nasze Usługi mogą zawierać linki do stron internetowych, platform lub usług podmiotów trzecich.</div>
      <div class="text">Nie ponosimy odpowiedzialności za praktyki podmiotów trzecich dotyczące prywatności.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XII. Wykorzystywanie nazw i logo marek podmiotów trzecich</div>
    <div class="text-box">
      <div class="text">Nasza strona internetowa może wyświetlać nazwy marek i logo, takie jak Apple, Samsung, OPPO, OnePlus, vivo, Xiaomi, Google i inne, wyłącznie w celu identyfikacji urządzeń kompatybilnych z naszymi Usługami.</div>
      <div class="text">Wszystkie znaki towarowe należą do ich odpowiednich właścicieli.</div>
      <div class="text">Danghuan jest niezależnym usługodawcą i nie jest powiązany z tymi markami ani przez nie rekomendowany, chyba że wyraźnie wskazano inaczej.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XIII. Aktualizacje niniejszej Polityki Prywatności</div>
    <div class="text-box">
      <div class="text">Zastrzegamy sobie prawo do okresowego aktualizowania niniejszej Polityki Prywatności.</div>
      <div class="text">Najnowsza wersja będzie zawsze dostępna na naszej stronie internetowej.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">B. POSTANOWIENIA DOTYCZĄCE RODO</div>
    <div class="text-box">
      <div class="text">Poniższe postanowienia mają zastosowanie wyłącznie do osób znajdujących się w Europie.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Podstawy prawne przetwarzania</div>
    <div class="text-box">
      <div class="text">Przetwarzamy Państwa dane osobowe na podstawie:</div>
      <div class="text">• Państwa zgody;</div>
      <div class="text">• konieczności wykonania umowy;</div>
      <div class="text">• konieczności wykonania obowiązków prawnych;</div>
      <div class="text">• naszych prawnie uzasadnionych interesów.</div>
      <div class="text">Nasze prawnie uzasadnione interesy mogą obejmować:</div>
      <div class="text">• zapobieganie oszustwom;</div>
      <div class="text">• ulepszanie Usług;</div>
      <div class="text">• analitykę;</div>
      <div class="text">• obsługę klienta;</div>
      <div class="text">• cyberbezpieczeństwo;</div>
      <div class="text">• zarządzanie działalnością;</div>
      <div class="text">• dochodzenie roszczeń i obronę prawną.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. Dodatkowe informacje dotyczące międzynarodowego przekazywania danych</div>
    <div class="text-box">
      <div class="text">Jeżeli dane osobowe są przekazywane poza Europę, zapewniamy odpowiednie zabezpieczenia, w tym:</div>
      <div class="text">• decyzje stwierdzające odpowiedni stopień ochrony;</div>
      <div class="text">• standardowe klauzule umowne;</div>
      <div class="text">• inne zgodne z prawem mechanizmy przekazywania danych.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III. Dodatkowe informacje dotyczące plików cookie</div>
    <div class="text-box">
      <div class="text">Dodatkowe informacje na temat plików cookie mogą być udostępniane w naszej Polityce Plików Cookie lub za pośrednictwem banera cookie.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. Dodatkowe informacje dotyczące Państwa praw</div>
    <div class="text-box">
      <div class="text">Na podstawie RODO mogą Państwu dodatkowo przysługiwać:</div>
      <div class="text">• prawo do wniesienia sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie;</div>
      <div class="text">• prawo do sprzeciwu wobec marketingu bezpośredniego;</div>
      <div class="text">• prawo do ograniczenia przetwarzania;</div>
      <div class="text">• prawo do wniesienia skargi do właściwego organu nadzorczego.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. Dane kontaktowe</div>
    <div class="text-box">
      <div class="text">W sprawach dotyczących ochrony danych osobowych mogą Państwo skontaktować się z nami:</div>
      <div class="text">Danghuan Europe S.L.Email: <span class="email">privacy@danghuan.euWebsite</span>: <a href="https://<a href="https://www.danghuan.eu"" target="_blank">www.danghuan.eu"</a> target="_blank">https://<a href="https://www.danghuan.eu" target="_blank">www.danghuan.eu</a></a></div>
      <div class="text">Mogą Państwo również złożyć skargę do właściwego lokalnego organu ochrony danych osobowych.</div>
    </div>
  </div>
`;
